import React from 'react';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { searchActions } from '../../../store/searchStore';
import NoDataComponent from '../../common/noDataComponent';
import Section from "../../common/section";
import Money from '../../common/moneyComponent';

import '../../../css/search/search.scss'

class LiensSearchResultPage extends React.Component {
    render() {
        if (isNullOrUndefined(this.props.data))
            return <NoDataComponent />

        return (
            <>
                {this.renderGeneralInfo(this.props.data)}
                {this.renderDataInfo("Search.Liens.Debtor", this.props.data.debtor)}
                {this.renderDataInfo("Search.Liens.Depositor", this.props.data.depositor)}
                {this.renderDataInfo("Search.Liens.Creditor", this.props.data.creditor)}
                {this.renderLiabilities("Search.Liens.Liabilities", this.props.data.liabilities)}
                {this.renderDeposits("Search.Liens.Deposit", this.props.data.deposits)}
            </>
        )
    }

    renderSection = (translationKey, content) => {
        return (
            <Section
                isSection={true}
                removeDataLevel={true}
                bodyStyle={{ border: "none" }}
                style={{ border: "none" }}
                headerStyle={{ marginLeft: "0", border: "none", cursor: "default" }}
                isOpen={true}
                name={this.props.translate(translationKey)}
            >
                {content}
            </Section>
        );
    }

    renderGeneralInfo = (item) => {
        return (
            <table className="table table-report-section key-value">
                <colgroup>
                    <col width="20%" />
                    <col width="80%" />
                </colgroup>
                <tbody>
                    <tr>
                        <td><Translate id="Search.Liens.General.FileId" /></td>
                        <td>{item.fileId}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Liens.General.DateOfRecord" /></td>
                        <td>{item.startDateFormated}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Liens.General.RegistrationType" /></td>
                        <td>{item.registrationType}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Liens.General.RegisteredBy" /></td>
                        <td>{item.registeredBy}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Liens.General.Status" /></td>
                        <td>{item.inactivityIndicator === '01' ? <Translate id="Search.Liens.General.Status.Deleted" /> : item.status.length === 0
                            ? <Translate id="Search.Liens.General.Status.Actual" />
                            : <span><Translate id="Search.Liens.General.Status.ChangedBy" />: {this.getChangingFilesLinks(item)} </span>}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    renderDataInfo = (translationKey, items) => {
        if (isNullOrUndefined(items) || items.length === 0)
            return null;

        return this.renderSection(translationKey,
            <table className="table table-report-section-3">
                <tbody>
                    {items.map(i => <tr key={i.id} className='colorize'>{this.getDataString(i)}</tr>)}
                </tbody>
            </table>
        )
    }

    renderLiabilities = (translationKey, items) => {
        if (isNullOrUndefined(items) || items.length === 0)
            return null;

        return this.renderSection(translationKey,
            <table className="table table-report-section">
                <thead>
                    <tr>
                        <th><Translate id="Search.Liens.Liabilities.Value" /> / <Translate id="Search.Liens.Liabilities.MaxValue" /></th>
                        <th><Translate id="Search.Liens.Liabilities.Currency" /></th>
                        <th><Translate id="Search.Liens.Liabilities.Type" /></th>
                        <th><Translate id="Search.Liens.Liabilities.DueDate" /></th>
                        <th><Translate id="Search.Liens.Liabilities.DeadlineDate" /></th>
                    </tr>
                </thead>
                <tbody>
                    {items.map(i =>
                        <tr key={i.id} className='colorize'>
                            <td><Money value={i.value} fractionDigits={2} /> / <Money value={i.maxValue} fractionDigits={2} /></td>
                            <td>{i.currency}</td>
                            <td>{i.lienDepositType}</td>
                            <td>{i.dueDateFormated}</td>
                            <td>{i.deadlineDateFormated}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        )
    }

    renderDeposits = (translationKey, items) => {
        if (isNullOrUndefined(items) || items.length === 0)
            return null;

        return this.renderSection(translationKey, 
            <table className="table table-report-section key-value">
                <colgroup>
                    <col width="20%" />
                    <col width="80%" />
                </colgroup>
                <tbody>
                    {items.map(i =>
                        <React.Fragment key={i.id}>
                            <tr key={`${i.id}_c`}>
                                <td><Translate id="Search.Liens.Deposit.Category" /></td>
                                <td>{i.category}</td>
                            </tr>
                            <tr key={`${i.id}_a`}>
                                <td><Translate id="Search.Liens.Deposit.Amount" /></td>
                                <td><Money value={i.value} fractionDigits={2} /></td>
                            </tr>
                            <tr key={`${i.id}_d`}>
                                <td><Translate id="Search.Liens.Deposit.Description" /></td>
                                <td>{i.description}</td>
                            </tr>
                            <tr key={`${i.id}_e`}>
                                <td><Translate id="Search.Liens.Deposit.EnforcementType" /></td>
                                <td>{i.lienEnforcementType}</td>
                            </tr>
                        </React.Fragment>
                    )}
                </tbody>
            </table>
        )
    }

    getChangingFilesLinks = (item) => {
        if (item.status.length === 0)
            return;

        return (
            <React.Fragment>
                {item.status.map((s, i) =>
                    <React.Fragment key={s.lienId}>
                        <a key={s.relatedLien} className="link-internal link-orange is-normal" style={{ display: "inline-flex" }} onClick={() => this.refClicked(s)} >{s.fileId}</a>
                        {i < item.status.length - 1 ? "; " : ""}
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    }

    getDataString = (item) => {
        return (
            <td>
                {isNullOrUndefined(item.subjectName) || item.subjectName.length === 0 ? null : <React.Fragment>{item.subjectName}; </React.Fragment>}
                {isNullOrUndefined(item.subjectIco) || item.subjectIco.length === 0
                    ? null : <React.Fragment><Translate id="Search.Common.CompanyId" />: {item.subjectIco}; </React.Fragment>}
                {isNullOrUndefined(item.subjectAddress) || item.subjectAddress.length === 0 ? null : <React.Fragment>{item.subjectAddress}</React.Fragment>}
            </td>
        )
    }

    refClicked = (ref) => {
        this.props.getLiens({ fileNumber: ref.fileNumber, page: 1, pageSize: 1 });
    }
}

export default withLocalize(connect(
    state => state.search,
    dispatch => bindActionCreators(searchActions, dispatch),
)(LiensSearchResultPage));